module.exports = __webpack_public_path__ + "jingTai/img/one.18f6fbf3.png";